import LangService from '../../services/lang';
import {
    QUIZ_DELETED,
    QUIZ_DELETING,
    QUIZ_DOWNLOADED,
    QUIZ_EDITING,
    QUIZ_PICTURE_FAILED,
    QUIZ_PICTURE_UPLOADING,
    QUIZ_POSTING,
    QUIZ_QUESTION_DOWNLOADED,
    QUIZ_QUESTION_PICTURE_FAILED,
    QUIZ_QUESTION_PICTURE_UPLOADING,
    QUIZ_RESET,
    QUIZZES_DOWNLOADED,
    QUIZZES_FAILED,
    QUIZZES_PENDING,
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: LangService.defaultTranslatedContent,
    pending: false,
    sending: false,
    currentQuiz: null,
    currentIndex: null,
    questionSending: null
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case QUIZZES_PENDING: {
            return {
                ...state,
                pending: true,
            };
        }
        case QUIZZES_FAILED: {
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
            };
        }
        case QUIZZES_DOWNLOADED: {
            let newContentPages = { ...state.content };
            newContentPages[action.payload.lang] = action.payload.quizzes;
            return {
                ...state,
                error: null,
                pending: false,
                sending: false,
                content: newContentPages,
            };
        }
        case QUIZ_DOWNLOADED: {
            let newContent = { ...state.content };
            let index = newContent[action.payload.lang]
                .findIndex(ac => ac.id === action.payload.quiz.id);
            if (index === -1) {
                newContent[action.payload.lang].push(action.payload.quiz);
            } else {
                newContent[action.payload.lang][index] = action.payload.quiz;
            }
            return {
                ...state,
                content: newContent,
                currentQuiz: action.payload.quiz,
                error: null,
                sending: false,
            };
        }
        case QUIZ_DELETING: {
            return {
                ...state,
                sending: true,
            };
        }
        case QUIZ_DELETED: {
            let newContent = { ...state.content };
            LangService.langs.forEach(function (l) {
                if (newContent[l.key] !== undefined) {
                    newContent[l.key] = state.content[l.key].filter((qu) => {
                        return qu.id !== action.payload.id;
                    });
                }
            });
            return {
                ...state,
                content: newContent,
                error: null,
                sending: false,
            };
        }
        case QUIZ_EDITING: {
            return {
                ...state,
                sending: true,
            };
        }
        case QUIZ_RESET: {
            return INITIAL_STATE;
        }
        case QUIZ_POSTING: {
            return {
                ...state,
                sending: true,
            };
        }
        case QUIZ_PICTURE_UPLOADING: {
            return {
                ...state,
                sending: true,
            };
        }
        case QUIZ_PICTURE_FAILED: {
            return {
                ...state,
                sending: false,
                error: action.payload,
            };
        }
        case QUIZ_QUESTION_PICTURE_UPLOADING: {
            return {
                ...state,
                questionSending: action.payload,
            };

        }
        case QUIZ_QUESTION_DOWNLOADED: {
            let newContent = { ...state.content };
            const quizIndex = newContent[action.payload.lang]
                .findIndex(qu => {
                    return qu.id === action.payload.quiz.id;
                });
            if (quizIndex !== -1) {
                const questionIndex = newContent[action.payload.lang][quizIndex]
                    .quiz_questions.findIndex((qu) => {
                        return qu.id === action.payload.question.id;
                    });
                if (questionIndex !== -1) {
                    newContent[action.payload.lang][quizIndex]
                        .quiz_questions[questionIndex] = action.payload.question;
                } else {
                    newContent[action.payload.lang][quizIndex]
                        .quiz_questions.push(action.payload.question);
                }
            }
            return {
                ...state,
                questionSending: null,
                content: newContent
            };
        }
        case QUIZ_QUESTION_PICTURE_FAILED: {
            return {
                ...state,
                questionSending: null,
                error: action.payload
            };
        }
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// src/store/quizzes/reducers.js